import {useEffect, useState} from 'react';

import {useTheme} from '../Utils/ThemeContext';

/* -------------------- Configuration: Theme Gradients -------------------- */
const GRADIENTS = {
    digital: 'from-blue-400 via-purple-500 to-cyan-400',
    print: 'from-pink-400 via-rose-500 to-cyan-400',
};

/* -------------------- Scroll Progress Calculation -------------------- */
const getScrollProgress = () => {
    const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
    return scrollHeight > 0 ? window.scrollY / scrollHeight : 0;
};

/* -------------------- Scroll Watcher -------------------- */
const ScrollWatcher = () => {
    const {theme} = useTheme();
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => setScrollProgress(getScrollProgress());
        window.addEventListener('scroll', handleScroll, {passive: true});
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const gradientClass = GRADIENTS[theme] || GRADIENTS.digital;

    return (
        <div
            className={`fixed top-0 left-0 right-0 h-[5px] z-50 bg-gradient-to-r ${gradientClass}`}
            style={{
                transform: `scaleX(${scrollProgress})`,
                transformOrigin: 'left',
            }}
            aria-hidden='true'
        />
    );
};

export default ScrollWatcher;
